import {navigate} from 'svelte-routing';
import servlet from './servlet.js';
import {store} from './stores.js';
import storage from './storage.js';
import {decode, parse_zayavka} from './helpers.js';

// подготовка приложения
export const prepare_app = async (login, password, handlerClick) => {
    // отключение axis and amo
    store('axis', '', false);
    store('amo', '', false);
    store('embed', '', '{}');
};

// режим встраивания через iframe: ?embed=true[&hide=footer,switcher]
// шапка скрывается всегда (axis-режим), а add_item уходит в parent через postMessage
const apply_embed = () => {
    if (location.query.embed !== 'true') {
        return;
    }

    console.debug('Mode', 'embed');

    const hide = decodeURIComponent(location.query.hide ?? 'footer,switcher').split(',').map((v) => v.trim());

    store('axis').save(true);
    store('amo').remove();
    store('embed').save({footer: hide.includes('footer'), switcher: hide.includes('switcher')});
};

// авторизация с параметрами
export const auth_by_params = async (user, handlerClick) => {
    if (location.query.credential) {
        let credential = JSON.parse(decode(location.query.credential));

        if (typeof credential === 'object') {
            console.debug('Auth via', 'credential');
            storage.setItem('credential', JSON.stringify(credential));

            if (location.query.axis === 'true') {
                console.debug('Mode', 'axis');
                store('axis').save(true);
            }
            if (location.query.amo === 'true') {
                console.debug('Mode', 'amo');
                store('amo').save(true);
            }
            if (location.query.widget === 'true') {
                console.debug('Mode', 'widget');
                store('axis').remove();
                store('amo').remove();
            }
            apply_embed();

            location.href = location.query.redirect ? location.query.redirect : '/dashboard';
        }
    } else if (location.query.auth) {
        // {"login": "alksily@...", "password": "xxx"}
        let auth = JSON.parse(decode(location.query.auth));

        if (typeof auth === 'object') {
            console.debug('Auth via', 'auth');

            if (location.query.axis === 'true') {
                console.debug('Mode', 'axis');
                store('axis').save(true);
            }
            if (location.query.amo === 'true') {
                console.debug('Mode', 'amo');
                store('amo').save(true);
            }
            if (location.query.widget === 'true') {
                console.debug('Mode', 'widget');
                store('axis').remove();
                store('amo').remove();
            }
            apply_embed();

            setTimeout(async () => {
                if (auth.login && auth.password) {
                    let result = await user.load({login: auth.login, password: auth.password});

                    if (result.id > 0) {
                        navigate('/dashboard');
                    }
                }
            }, 50);
        }
    } else {
        if (storage.getItem('embed')) {
            store('embed').remove();
        }
        if (storage.getItem('axis')) {
            storage.removeItem('axis');
            location.reload();
        }
        if (storage.getItem('amo')) {
            storage.removeItem('amo');
            location.reload();
        }
    }

    // удаляем старые параметры
    if (storage.getItem('params')) {
        storage.removeItem('params');
    }

    // сохранение параметров
    if (Object.keys(location.query).length) {
        storage.setItem('params', JSON.stringify(location.query));
    }

    // редирект если просят
    if (storage.getItem('credential') && location.query.redirect) {
        location.href = location.query.redirect;
    }
};

// переход к заказу
export const open_order = async (user_email) => {
    let data = storage.getItem('params');

    if (data) {
        data = JSON.parse(data);

        if (typeof data === 'object' && data.order && user_email) {
            setTimeout(async () => navigate('/dashboard' + location.search), 250);
        }
    }
};

// загрузка заказа из ТМ
export const load_order = async (cart, cart_data) => {
    let data = storage.getItem('params');

    if (data) {
        data = JSON.parse(data);

        if (typeof data === 'object' && data.order && data.orderStr) {
            console.debug('Event', 'load order');

            let result = await parse_zayavka(parseInt(atob(data.order)), data.orderStr),
                recipient = result.recipient,
                items = result.items;

            if (Object.entries(items).length) {
                cart_data.save(recipient);
                cart.save(items);
                document.querySelector('[data-bs-target="#cartPanel"]').click();
            }
        }
    }
};

// загрузка и возврат заказа из ТМ
export const get_order = async (order, orderStr, vid) => {
    if (order && orderStr) {
        console.debug('Event', 'load order');

        return parse_zayavka(parseInt(atob(order)), orderStr, vid)
    }

    return null
};

// заполняем данные по клиента из заказа из сервлета
export const load_client = async (cart, cart_data, user) => {
    let data = storage.getItem('params');

    if (data) {
        data = JSON.parse(decodeURIComponent(data))

        switch (APP_TYPE) {
            case 'profile-doors':
            case 'axis-one': {
                if (
                    data?.amo === "true" && data?.client_id &&
                    typeof data === 'object' &&
                    typeof servlet['axis-one'] === 'object' &&
                    typeof servlet['axis-one'].getUser === 'function'
                ) {
                    let resultAmo = await servlet['axis-one'].getUser(data);

                    if (typeof resultAmo === 'object' && Object.keys(resultAmo).length) {
                        console.debug('Event', 'load user');

                        let resultAxis = await parse_zayavka(resultAmo.nomDoc, resultAmo.nomDocStr);

                        if (resultAxis.recipient.address) {
                            resultAmo.address = resultAxis.recipient.address;
                        }
                        if (resultAxis.recipient.comment) {
                            resultAmo.comment = resultAxis.recipient.comment;
                        }

                        cart_data.save(resultAmo);

                        if (Object.entries(resultAxis.items).length) {
                            cart.save(resultAxis.items);
                            document.querySelector('[data-bs-target="#cartPanel"]').click();
                        }
                    }
                } else {
                    cart_data.save(data);
                }

                break;
            }

            default: {
                cart_data.save(data);
                break;
            }
        }
    } else {
        // подставляем имя, емейл и телефон дилера в данные клиента..
        if (user) {
            let {idtip, name, email, tel} = user.get();

            if (idtip === '2') {
                cart_data.save({...cart_data.get(), fio: name, email, tel});
            }
        }
    }
};

// отправляем номер документа
export const send_nomdoc = async (number, cart_items) => {
    let data = storage.getItem('params');

    if (data) {
        data = JSON.parse(data);

        switch (APP_TYPE) {
            case 'profile-doors':
            case 'axis-one': {
                if (
                    data?.amo === "true" && data?.client_id &&
                    typeof data === 'object' &&
                    typeof servlet['axis-one'] === 'object' &&
                    typeof servlet['axis-one'].sendNomDoc === 'function'
                ) {
                    console.debug('Event', 'send nom doc');

                    servlet['axis-one'].sendNomDoc(data, number, cart_items);
                }
            }
        }
    }
};
